import React from 'react'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'
import NameColumn from './NameColumn'

export const storeNameColumn = {
  id: REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME,
  classNameHeader: 'flex-row cell-title',
  classNameRow: 'flex-row cell-title',
  translation: ['search.table.shop'],
  HeaderAdditionalComponent: ({ onFilter, type }) => {
    const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

    return <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />
  },
  RowRenderer: childProps => <NameColumn childProps={childProps} />,
}

export const storeNameColumnWithL4L = {
  ...storeNameColumn,
  RowRenderer: childProps => {
    const { store } = childProps

    return <NameColumn childProps={childProps}>{store.isL4L && <span className="fm fm-l4l l4l-small mobile-only" />}</NameColumn>
  },
}

export const l4lColumn = {
  id: REVENUE_SORT_COLUMNS.L4L,
  classNameHeader: 'tablet-portrait-up-only cell-l4l cell-icons',
  classNameRow: 'cell cell-l4l cell-icons tablet-portrait-up-only',
  translation: ['revenue.table.category'],
  hideDefaultHeader: true,
  HeaderAdditionalComponent: childProps => (
    <Box display="inline" className="fm fm-l4l" onClick={childProps.onFilter} data-value={childProps.id} />
  ),
  RowRenderer: childProps => {
    const { store } = childProps

    return store.isL4L && <i className="fm fm-l4l" />
  },
}
